import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setUserData } from '../../../../Redux/user/userSlice';
import {
  setServiceOrdersList,
  fetchServiceOrderDetails,
  fetchPurchaseOrderDetails,
} from '../../../../Redux/complaints/complaintsSlice';
import { setTechniciansList } from '../../../../Redux/services/technicianSlice';
import {
  setServiceOrderStats,
  setIsServiceStatsLoading,
} from '../../../../Redux/services/dashboardSlice';

const apiUrl = process.env.REACT_APP_OMS_API;
const apiNestUrl = process.env.REACT_APP_OMS_NEST_API
// const apiNestUrl = "http://localhost:3008/rest/v1"


export const fetchServiceOrdersLists = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setServiceOrdersList(response?.data));
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const exportServiceOrders = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
  const config = {
    method: 'POST',
    url: `${apiNestUrl}/automation/service-order-report`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      exportType: 'ServiceOrders',
      dateFrom: params?.date_from || params?.dateFrom,
      dateTo: params?.date_to || params?.dateTo || params?.date_from,
      country: params?.country || authUser?.country || 'ae',
      status: params?.status || '',
      serviceType: params?.service_type || params?.serviceType || '',
      emirate: params?.emirate || '',
      technicianId: params?.technician_id || params?.technicianId || '',
      reportType: (params?.report_type || params?.reportType || 'normal').toLowerCase(),
      format: (params?.format || 'xlsx').toLowerCase(),
      userId: authUser?.user_id || authUser?.id || '',
      email: authUser?.user_email || authUser?.email || '',
      name: authUser?.user_name || authUser?.name || '',
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    return error?.response?.data || { status: 'failed', message: 'Export failed' };
  }
};

// Fetch user info by mobile number, serial number, or SO number
export const fetchUserByMobile = async ({
  mobile,
  serial_no,
  so_no,
  country = 'ae',
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/purchase-details-by-mobile`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      // country,
      mobile: mobile ? '971' + mobile : undefined,
      serial_no,
      so_no,
    }),
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401 && dispatch) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

export const fetchOrderDetails = async ({
  searchBy,
  value,
  country = 'ae',
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/purifier-data-lookup`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      searchBy: searchBy,
      value: value,
    }),
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401 && dispatch) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

// Create complaint API (multipart/form-data)
export const createServiceOrder = async ({
  customer_name,
  country,
  mobile,
  alternate_mobile = '',
  order_no = '',
  remarks = '',
  qty = '',
  model_no = '',
  serial_no = '',
  product_type = '',
  service_type = '',
  complaint_detail_category = '',
  created_by = '',
  oms_user_id = '',
  user_empid = '',
  email = '',
  address = '',
  area = '',
  emirate = '',
  city = '',
  address2 = '',
  building = '',
  street = '',
  flat_no = '',
  floor_no = '',
  landmark = '',
  company_name = '',
  trn_no = '',
  latitude = '',
  longitude = '',
  files = [],
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const formData = new FormData();
  // Attach files (multiple allowed)
  if (files && files.length > 0) {
    files.forEach((file) => {
      formData.append('user_image[]', file);
    });
  }
  formData.append('customer_name', customer_name);
  formData.append('country', country);
  formData.append('mobile', mobile);
  formData.append('alternate_mobile', alternate_mobile);
  formData.append('order_no', order_no);
  formData.append('qty', qty);
  formData.append('remarks', remarks);
  formData.append('product_type', product_type);
  formData.append('service_type', service_type);
  formData.append('complaint_detail_category', complaint_detail_category);
  formData.append('created_by', created_by);
  formData.append('oms_user_id', oms_user_id);
  formData.append('user_empid', user_empid);
  formData.append('email', email);
  formData.append('address', address);
  formData.append('areaName', area);
  formData.append('emirate', emirate);
  formData.append('city', city);
  formData.append('address2', address2);
  formData.append('buildingName', building);
  formData.append('streetName', street);
  formData.append('flatNo', flat_no);
  formData.append('floorNumber', floor_no);
  formData.append('nearestLandmark', landmark);
  formData.append('companyName', company_name);
  formData.append('trnNo', trn_no);
  formData.append('latitude', latitude);
  formData.append('longitude', longitude);
  formData.append('budget_category', 'Purifier');
  formData.append('source', 'oms');
  formData.append('store', 'PURF');
  formData.append('model_no', model_no);
  formData.append('serial_no', serial_no);

  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/create`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'multipart/form-data',
      'X-source': 'oms',
      // 'Content-Type' will be set automatically by axios for FormData
    },
    data: formData,
  };
  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    if (error?.response?.status === 401 && dispatch) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

// Fetch Service Order Details
export const getServiceOrderDetails = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/service-details`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(fetchServiceOrderDetails(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

// Fetch Purchase Order Details
export const getPurchaseOrderDetails = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/purchase-details`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(fetchPurchaseOrderDetails(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const assignToTechnician = async ({
  service_no,
  technician_id,
  comment,
  scheduled_date,
  updated_by,
  created_by,
  user_empid,
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/assign-technician`,
    // url: `https://0594-83-110-147-121.ngrok-free.app/api/v1/service-order/assign-technician`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      service_no,
      technician_id,
      comment,
      scheduled_date,
      updated_by,
      created_by,
      user_empid,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

// Shared in-flight request so multiple components mounting at once
// (e.g. the list page + export report) trigger only one network call.
let techniciansListPromise = null;

//fetch tecnitions list and store in redux
export const getTechniciansList = async ({ dispatch, force = false } = {}) => {
  // Reuse the in-flight / previously resolved request unless a refresh is forced.
  if (techniciansListPromise && !force) {
    return techniciansListPromise;
  }

  const fetchTechnicians = async () => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'GET',
      url: `${apiUrl}v1/service-order/list-technician`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
    };
    try {
      const response = await axios(config);
      if (response?.data?.code === 100) {
        dispatch(setTechniciansList(response?.data));
      }
      return response?.data;
    } catch (error) {
      // Allow a retry on the next call if this request failed.
      techniciansListPromise = null;
      if (error?.response?.status === 401) {
        dispatch(setUserData(null));
        window.location.replace('/logout');
      }
    }
  };

  techniciansListPromise = fetchTechnicians();
  return techniciansListPromise;
};

export const updateCustomerAddress = async ({ addressObj, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/update-address`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...addressObj,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const sendWhatsAppMessage = async ({
  service_no,
  customer_name,
  mobile,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiNestUrl}/order/send-whatsapp-message`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      service_no,
      customer_name,
      mobile,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
  }
};


export const fetchServiceOrderStats = async ({ params, dispatch }) => {
  dispatch(setIsServiceStatsLoading(true));
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/dashboard-stats`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setServiceOrderStats(response?.data));
  } catch (error) {
    dispatch(setIsServiceStatsLoading(false));
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

//fetch models list
export const getModelList = async () => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/get-purifier-models`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
  }
};

//update cancel status
export const updateStatus = async ({
  service_id,
  status_code,
  remarks,
  created_by,
  user_empid,
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/update`,
    // url: `https://0594-83-110-147-121.ngrok-free.app/api/v1/service-order/assign-technician`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      service_id,
      status_code,
      remarks,
      created_by,
      user_empid,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const updatePurifierOrder = async ({
  ls_order_no,
  model_no,
  complaint_no,
  serial_no,
  warranty,
  installation_date,
  warranty_end_date,
  amc_start_date,
  amc_end_date,
  sku,
  master_id,
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/purifier-order/update`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ls_order_no,
      model_no,
      complaint_no,
      serial_no,
      warranty,
      installation_date,
      warranty_end_date,
      amc_start_date,
      amc_end_date,
      sku,
      master_id,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

// Fetch technician inventory (consumables / spare parts / amc) by model
export const getInventoryByModel = async ({
  technicianId,
  country = 'ae',
  model_no,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/item-list-bymodel`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      technicianId,
      country,
      model_no,
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
    return error?.response?.data || null;
  }
};

// Mark a service order as a free service
export const makeFreeService = async ({
  service_id,
  remarks,
  created_by,
  user_empid,
  dispatch,
}) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/make-free-service`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      service_id,
      remarks,
      created_by,
      user_empid,
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    return error?.response?.data || null;
  }
};

export const getAreaList = async () => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'GET',
    url: `${apiUrl}v1/service-order/area-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
  }
};